/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsReplayChampionPairDtoSchema } from "./replayChampionPairDtoSchema.ts";
import { goodLuckCoreDTOsReplayMetricValueDtoSchema } from "./replayMetricValueDtoSchema.ts";
import { goodLuckCoreDTOsReplayTeamObjectivesDtoSchema } from "./replayTeamObjectivesDtoSchema.ts";
import { goodLuckCoreDTOsReplayTeamPlayerDtoSchema } from "./replayTeamPlayerDtoSchema.ts";
import { goodLuckCoreDTOsReplayTeamTotalsDtoSchema } from "./replayTeamTotalsDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsReplayTeamMetricsDtoSchema = z.object({
  teamId: z.string().nullish(),
  teamName: z.string().nullish(),
  teamSide: z.string().nullish(),
  matchId: z.string().nullish(),
  gameId: z.int().nullish(),
  gamesTotal: z.optional(z.int()),
  wins: z.optional(z.int()),
  durationSeconds: z.number().nullish(),
  playerRows: z.optional(z.int()),
  get totals() {
    return goodLuckCoreDTOsReplayTeamTotalsDtoSchema.optional();
  },
  get objectives() {
    return goodLuckCoreDTOsReplayTeamObjectivesDtoSchema.optional();
  },
  get metrics() {
    return z.array(goodLuckCoreDTOsReplayMetricValueDtoSchema).nullish();
  },
  get players() {
    return z.array(goodLuckCoreDTOsReplayTeamPlayerDtoSchema).nullish();
  },
  get championPairs() {
    return z.array(goodLuckCoreDTOsReplayChampionPairDtoSchema).nullish();
  },
});
